import React, { Component, createRef } from 'react'

import configData from './config-toolbar.json'

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './index_v1.css'

import { Editor } from 'react-draft-wysiwyg'
import { EditorState, ContentState, Modifier, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'

import { nanoid } from 'nanoid'
import LabelMessage from '../utils/label-message'

const WAIT_INTERVAL = 2000

class TextEditorComponent extends Component {
  constructor(props) {
    super(props)

    let editorState = EditorState.createEmpty()
    const contentBlock = htmlToDraft(props.value)

    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
      editorState = EditorState.createWithContent(contentState)
    }

    this.state = {
      editorState: editorState,
      value: props.value,
      label: props.label,
      help: props.help,
      onFocus: false,
      id: props.id,
    }

    this.wrapperRef = createRef()
  }

  onFocus = () => {
    this.setState({ onFocus: true })
  }
  onBlur = () => {
    this.setState({ onFocus: false })
  }

  componentDidMount() {
    this.timer = null
    this.wrapperRef.current.addEventListener('wheel', this.handleWheel, { passive: false })
  }

  componentWillUnmount() {
    this.wrapperRef.current.removeEventListener('wheel', this.handleWheel)
  }

  handleWheel = e => {
    const editorEl = this.wrapperRef.current.querySelector('.DraftEditor-editorContainer')
    if (!editorEl) return

    const { scrollTop, scrollHeight, clientHeight } = editorEl
    const atTop = scrollTop === 0 && e.deltaY < 0
    const atBottom = scrollTop + clientHeight >= scrollHeight && e.deltaY > 0

    if (!atTop && !atBottom) {
      e.stopPropagation()
      e.preventDefault()
      editorEl.scrollTop += e.deltaY
    }
  }

  handleChange = editorState => {
    clearTimeout(this.timer)

    let content = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    this.setState({ editorState: editorState, value: content })

    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL)
  }

  handlePastedText = (text, html, editorState, onChange) => {
    const selection = editorState.getSelection()
    const plainContent = ContentState.createFromText(text)
    const newContentState = Modifier.replaceWithFragment(
      editorState.getCurrentContent(),
      selection,
      plainContent.getBlockMap(),
    )
    onChange(EditorState.push(editorState, newContentState, 'insert-fragment'))
    return 'handled'
  }

  triggerChange = () => {
    this.props.update(this.props.field, this.state.value)
  }

  render() {
    let config = configData
    let editorState = this.state.editorState

    return (
      <div>
        <LabelMessage label={this.state.label} help={this.state.help} id={nanoid()} />

        <div ref={this.wrapperRef} tabIndex={0} onFocus={this.onFocus} onBlur={this.onBlur}>
          <Editor
            editorState={editorState}
            onEditorStateChange={this.handleChange}
            handlePastedText={this.handlePastedText}
            toolbar={config}
          />
        </div>
        <div className={`text-input-border-bottom ${this.state.onFocus ? 'active' : ''}`} />
      </div>
    )
  }
}

TextEditorComponent.defaultProps = { field: 'field', value: '', label: '', help: '' }

export default TextEditorComponent
